import { useState } from "react";

/**
 * Custom hook for managing appointment booking operations
 * Handles booking modal state and appointment data management
 */
export const useAppointmentBooking = () => {
  const [isBookAppointmentOpen, setIsBookAppointmentOpen] = useState(false);
  const [selectedPatientForBooking, setSelectedPatientForBooking] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAppointmentData, setSelectedAppointmentData] = useState(null);

  // Handle booking appointment for regular and emergency cases
  const handleBookAppointment = (patientData, isEmergency = false) => {
    console.log("handleBookAppointment called with:", patientData, "isEmergency:", isEmergency);
    setSelectedPatientForBooking({
      ...patientData,
      isEmergency: isEmergency
    });
    setIsBookAppointmentOpen(true);
  };

  // Handle emergency appointment booking
  const handleEmergencyAppointment = (patientData) => {
    // Set the patient data with emergency flag
    const appointmentData = {
      id: patientData.id || patientData.patient_id,
      patientName: patientData.name,
      patientId: patientData.patient_code || patientData.id,
      patientGender: patientData.gender,
      patientAge: patientData.age,
      phone_no: patientData.phoneNumber || patientData.phone_no,
      isEmergency: true
    };

    // Set the selected appointment data which will trigger the edit modal
    setSelectedAppointmentData(appointmentData);
    setIsEditModalOpen(true);
  };

  // Close booking modal
  const closeBookingModal = () => {
    console.log("Modal closing");
    setIsBookAppointmentOpen(false);
    setSelectedPatientForBooking(null);
  };

  // Close edit modal
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedAppointmentData(null);
  };

  return {
    // State
    isBookAppointmentOpen,
    selectedPatientForBooking,
    isEditModalOpen,
    selectedAppointmentData,

    // Actions
    handleBookAppointment,
    handleEmergencyAppointment,
    closeBookingModal,
    closeEditModal,
    setIsBookAppointmentOpen,
    setSelectedPatientForBooking,
    setIsEditModalOpen,
    setSelectedAppointmentData
  };
};